<div
  class="notification-preview"
  [innerHTML]="content | safeHtml"
  *ngIf="isEmail && template"></div>
<div *ngIf="!isEmail && data">
  <div class="phone">
    <div class="screen">
      <div class="message" *ngIf="data[locale].message">
        <pre>{{ data[locale].message }}</pre>
      </div>
    </div>
  </div>
</div>
